import { Col, Container, Row } from "reactstrap";
import { H3, H5 } from "../../../../AbstractElements";
import { CartEmpty, ExploreShortlistItems } from "../../../../Constants/Constants";

const EmptyCart = () => {
  return (
    <section className="cart-section section-b-space p-5">
      <Container fluid>
        <Row>
          <Col sm="12">
            <div>
              <Col sm="12" className="empty-cart-cls text-center">
                <H3>
                  <strong>{CartEmpty}</strong>
                </H3>
                <H5>{ExploreShortlistItems}</H5>
              </Col>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default EmptyCart;
